import React from 'react'

import { css } from '@portal/styled-system/css'

import { LoginButtons } from '@/features/social-button'
import { useI18n } from '@/shared/lib/i18n'
import { Button, Divider } from '@/shared/ui'

import { LoginFormBody } from './login/form'
import * as steps from './steps'

export function LoginCardBody() {
    const { i18n } = useI18n()

    const handleSignupClick = () => {
        steps.showStepSignupEmail()
    }

    return (
        <React.Fragment>
            <div className={css({ color: 'gray-v2.700', textAlign: 'center', marginBottom: '2' })}>
                {i18n.TEXT_NEW_USER}&nbsp;
                <Button onPress={handleSignupClick} color="cyan" variant="plain">
                    {i18n.LINK_SIGNUP_HERE}
                </Button>
            </div>
            <div className={css({ width: 'full' })}>
                <LoginFormBody />
            </div>
            <Divider>{i18n.TEXT_OR}</Divider>
            <LoginButtons styles={css.raw({ paddingBottom: '2' })} />
        </React.Fragment>
    )
}
